// extracted by mini-css-extract-plugin
export default {"carousel":"carousel_carousel__DZopZ","body":"carousel_body__gH-1W","indicator":"carousel_indicator__gZqAA","active":"carousel_active__WHbXW","navigator":"carousel_navigator__K73ze"};